export const SubscriptionDetailsContants = {
  GET_SUBSCRIPTION_DETAILS_REQUEST: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_DETAILS_REQUEST',
  GET_SUBSCRIPTION_DETAILS_SUCCESS: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_DETAILS_SUCCESS',
  GET_SUBSCRIPTION_DETAILS_ERROR: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_DETAILS_ERROR',
  GET_SUBSCRIPTION_DETAILS_ERROR: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_DETAILS_ERROR',
  GET_ACCOUNT_BILL_PLAN_REQUEST: 'ACCOUNT_BILL_PLAN/GET_ACCOUNT_BILL_PLAN_REQUEST',
  GET_ACCOUNT_BILL_PLAN_SUCCESS: 'ACCOUNT_BILL_PLAN/GET_ACCOUNT_BILL_PLAN_SUCCESS',
  GET_ACCOUNT_BILL_PLAN_ERROR: 'ACCOUNT_BILL_PLAN/GET_ACCOUNT_BILL_PLAN_ERROR',
  GET_SUBSCRIPTION_ALL_PLANS_DETAILS_REQUEST: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_ALL_PLANS_DETAILS_REQUEST',
  GET_SUBSCRIPTION_ALL_PLANS_DETAILS_SUCCESS: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_ALL_PLANS_DETAILS_SUCCESS',
  GET_SUBSCRIPTION_ALL_PLANS_DETAILS_ERROR: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_ALL_PLANS_DETAILS_ERROR',
  GET_SUBSCRIPTION_BILLPLANDETAILS_SUCCESS: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_BILLPLANDETAILS_SUCCESS',
  GET_SUBSCRIPTION_CREDITPLANDETAILS_SUCCESS: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_CREDITPLANDETAILS_SUCCESS',
  GET_SUBSCRIPTION_OVERALLBILLPLAN_SUCCESS: 'SUBSCRIPTION_DETAILS/GET_SUBSCRIPTION_OVERALLBILLPLAN_SUCCESS'
};
